import * as React from 'react';
import { Grid } from '../helpers/Grid';
import Container from '../helpers/Container';
import { Image, Content } from '../common';
import ContentBlockProps from './type';
import './styles.scss';

const ContentBlock = ({
  title,
  intro,
  content,
  contact,
  link,
  secondaryLink,
  downloads,
  image,
  themeColor,
  disableUppercase,
  useGroupedDownloads,
  groupedDownloads,
}: ContentBlockProps) => {
  let contentWidth = {
    sm: 6, md: 8, lg: 8, xl: 11,
  };

  const hasDownloads = useGroupedDownloads
    ? groupedDownloads && Object.keys(groupedDownloads).length > 0
    : downloads && downloads.length > 0;

  if (image && !hasDownloads) {
    contentWidth = {
      sm: 6, md: 3, lg: 3, xl: 4,
    };
  }
  if (image && hasDownloads) {
    contentWidth = {
      sm: 6, md: 4, lg: 4, xl: 6,
    };
  }

  return (
    <div className={`content-block content-block--${themeColor}`}>
      <Container>
        <Grid className="content-block__container">
          <Grid.Column {...contentWidth} className="content-block__content">
            <Content
              title={title}
              intro={intro}
              content={content}
              contact={contact}
              downloads={downloads}
              link={link}
              secondaryLink={secondaryLink}
              containerTheme={themeColor}
              isTitleFloating={!image}
              disableUppercase={disableUppercase}
              useGroupedDownloads={useGroupedDownloads}
              groupedDownloads={groupedDownloads}
            />
          </Grid.Column>

          {image && (
            <Grid.Column sm={6} md={4} lg={hasDownloads ? 3 : 4} xl={hasDownloads ? 3 : 6} className="content-block__illustration">
              <Image url={image.file?.url} alt={image.title} widthSizes={['400', '800', '1000']} />
              <div className="content-block__illustration-details">
                {image.description && (
                  <div className="content-block__illustration-description">
                    {image.description}
                  </div>
                )}

                {(image.credit) && (
                  <small className="content-block__illustration-copyright">
                    &copy;&nbsp;
                    {image.credit}
                  </small>
                )}
              </div>
            </Grid.Column>
          )}
        </Grid>
      </Container>
    </div>
  );
};

export default ContentBlock;
